import { render, staticRenderFns } from "./EscalateModal.vue?vue&type=template&id=4d1ac34c&scoped=true&"
import script from "./EscalateModal.vue?vue&type=script&lang=js&"
export * from "./EscalateModal.vue?vue&type=script&lang=js&"
import style0 from "./EscalateModal.vue?vue&type=style&index=0&id=4d1ac34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ac34c",
  null
  
)

export default component.exports